export type ProjectDisplayInput = {
  name?: string | null;
  projectTypeName?: string | null;
  startDate?: string | null;
  country?: string | null;
};

const normalizeText = (value?: string | null): string =>
  (value || "").trim();

const getPrefixFromProjectType = (projectTypeName?: string | null): string => {
  const value = normalizeText(projectTypeName);
  if (!value) {
    return "PR";
  }

  const compact = value.replace(/\s+/g, "");
  if (!compact) {
    return "PR";
  }

  return compact.slice(0, 2).toLocaleUpperCase("tr-TR");
};

const getDateCode = (startDate?: string | null): string => {
  const raw = normalizeText(startDate);
  if (!raw) {
    return "";
  }

  const base = raw.split("T")[0];
  const digits = base.replace(/-/g, "");
  if (/^\d{8}$/.test(digits)) {
    return digits.slice(2);
  }

  const parsed = new Date(raw);
  if (Number.isNaN(parsed.getTime())) {
    return "";
  }

  const year = String(parsed.getFullYear()).slice(-2);
  const month = String(parsed.getMonth() + 1).padStart(2, "0");
  const day = String(parsed.getDate()).padStart(2, "0");
  return `${year}${month}${day}`;
};

export const buildProjectCode = (input: ProjectDisplayInput): string => {
  const prefix = getPrefixFromProjectType(input.projectTypeName);
  const dateCode = getDateCode(input.startDate);
  if (!dateCode) {
    return `${prefix}-`;
  }

  return `${prefix}-${dateCode}`;
};

export const formatProjectDisplayName = (
  input: ProjectDisplayInput
): string => {
  const trimmedName = normalizeText(input.name);
  const code = buildProjectCode(input);

  if (!trimmedName) {
    return code.replace(/-$/, "");
  }

  if (!code) {
    return trimmedName;
  }

  return code.endsWith("-") ? `${code}${trimmedName}` : `${code}-${trimmedName}`;
};
